import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import Aura from '@primeng/themes/aura';
import { CookieService } from 'ngx-cookie-service';
import { providePrimeNG } from 'primeng/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { jwtInterceptor } from './core';
import { cleanParamsInterceptor } from './core/interceptors/clean-params.interceptor';
import { CambiarContraseniaComponent } from './features/cambiar-contrasenia/cambiar-contrasenia.component';
import { SharedModule } from './shared';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@NgModule({
  declarations: [AppComponent, CambiarContraseniaComponent],
  imports: [BrowserModule, AppRoutingModule, SharedModule, ToastModule],
  providers: [
    MessageService,
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    provideHttpClient(
      withInterceptors([jwtInterceptor, cleanParamsInterceptor]),
    ),
    CookieService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
